import { Fragment, useEffect, useState } from "react";
import styles from "./Statement.module.css";
import store from "../../Store/Store";
import axios from "axios";
import config from "../../config/config";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../useDebouncedLog";

const Statement = observer(() => {
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedmonth] = useState("");
  const [gotResponse, setGotResponse] = useState(false);
  const [data, setData] = useState();
  const [Clicked, setClicked] = useState(false);
  const [ShowSuccess, setShowSuccess] = useState(false);
  const [ClickedStmt, setClickedStmt] = useState("");
  const [Error, setError] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState({});
  const [DownloadingProgess,setDownloadingProgess]=useState(false)
  // {
  //   Title: "Network issue",
  //   message: "Poor or lost internet connection during download",
  // }    ErrorMsg example

  var logStatementsVisited;
  var logStatementsDownloded;
  try {
    logStatementsVisited = useDebouncedLog("admin_statements_visited", 500);
    logStatementsDownloded = useDebouncedLog("admin_statements_downloded", 500);
  } catch (err) {
    console.log("error", err);
  }

  let monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const generateYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  useEffect(() => {
    logStatementsVisited();
  }, [logStatementsVisited]);

  useEffect(() => {
    setSelectedYear("");
    setGotResponse(false);
    const startYear = 2025;
    setYearOptions(generateYearOptions(startYear));
  }, [store.refresh]);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  const GetStatementsData = (year, month) => {
    setData([]);
    setGotResponse(false);
    // setCombineMessage("");
    // setCombineError("");

    if (!year || !month) return;

    const monthNumber = monthOptions.indexOf(month) + 1;
    const formattedMonth = String(monthNumber).padStart(2, "0");

    const obj = {
      ledger_label: store.Company_Id,
      year: year,
      month: formattedMonth,
    };

    try {
      let tokens = JSON.parse(localStorage.getItem("authToken") || "{}");
      const expired = isTokenExpired(tokens.IdToken);

      if (expired) {
        getNewTokens(tokens);
        return;
      }

      const payload = {
        method: "post",
        url: `${config.node_api_endpoint}/cupi/admin/get_monthly_spend_daily`,
        headers: {
          aws_cognito_id_token: tokens.IdToken,
          aws_cognito_access_token: tokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios.request(payload)
        .then((response) => {
          setGotResponse(true);
          setData(response.data.data || []);
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        });
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const handleDownloadStatement = async (month, url) => {
    // setSelectedmonth(month);
    console.log(`Downloading report for ${month} ${selectedYear}`);

    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `statement-${month}-${selectedYear}.pdf`; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      try {
        logStatementsDownloded();
      } catch (er) {
        console.log("error", er);
      }
    }
  };

  const DownloadMonthlyStatements = async (resData) => {
    console.log("resData", resData);

    let url = resData?.url || resData?.presignedUrl || resData; // adjust based on your actual structure
    url =
      "https://production-cupi-stmts.s3.ap-south-1.amazonaws.com/EscrowStackPine/2026/02/2026-02-06-Cupi-Statements.csv?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAQFC27O3OQWYJNDIJ%2F20260423%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260423T105549Z&X-Amz-Expires=86400&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEJr%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiAScSkeDbIdAV60VM287VJa5mDcqihCoPFjALFhIMCCPAIhAKzy8FxQD4wjH38Uf2XAqkUtzUuTdd%2BIhOrfzBep4QPdKr4FCGMQABoMMDEwOTI4MjIzOTY1Igz4CVimDWDyHplIz3AqmwVmd7Dlkq4eRTFxS7DFnfXqYrwYidtfxXFupk%2F2InV2TJ%2B5Iw4nf86pr3Y5ch34xU%2BHqCk2Q8%2Bc0mn2A0ow3tG%2FwHxJVx%2BMASDY4wS8eqRiBjpisFl7wEaO1ztf6WSEWbN9Nw6jgOBctB7xpfZLGohjd%2Ft7qkb9mGaQmubw7WoTd3p%2B8XnFQJesfl4091rB4zmKu2n2LmyIF8eLYqB6Uv3yZoccX8iF1jEpQRt3bP5gYn5lk2SesID3iE3wZzVoYMbO8AAwqtFs%2BI1twrQf15yhhsLeeaWW4P43mzGsrCF1uzBs%2B6rrRRy5w9dCicJZOZF87Z84Gys%2B0pqiy%2FCO7Et4emZ9LA2GAo0gOTJ0v%2FoyKrPQ27sZpE6zuWDjWb7%2BbSYqpisfn88Umo3ZIYJAhRlPWyKJ3OyftTN2QuO8OdfyutDoUwPkCRlfL5cf8UWBuZkuR9V9U%2BFih1%2BT%2BT1dGsdzySLKL2DLhMRRUyvdzQICMHpBGCBs2MQEw%2F8X14dwRe82LPfAX2GcrQQsFgbhQ9S4UtSosxgCMTzdn5PUV0sGgE%2BM%2F1YZbebHjlHkKYB%2BnyC6II9RTlsJAaXmWd9Bz2CLgQnmDMVFrg%2FRW9hjeoyh%2BMRSXnczsD3LvzMqAMJZxJ924yFOrzeHHV1OrZWjW6yeYxLxJXsRsGOojTZfviRmW%2BVX%2Fm1qpC14Ji3CkCr6L9tL21clKxiKQHe9sRlrZtRSRoJs9nmRdRvJC%2Bn%2B9WZmKeF2YXpNfUgXlFNIdyKb2oJlrTRI4qtlpy6E3tKqBRmgsfnLpgimaXbTM6W2cmwaqfef64pELf6Mnj5I55Wvjsxs80zLPQSudJo44YFvWopXSis91qfzQbGJf0rZ8hlgFvY5w1xG9ALjycFcMJrYp88GOrEBiS0JFjHAcTrAnaYtqVXLWnlXYF%2FrxkSU2FrPNf%2BupMfLXHndLIw8YU0RjKDSeJdY822tKyLJdI4JOaV1usu0URZzLJ%2FW1LGrRh3tqhGEPpEyt35nJIug9X18KYuBp19Z94hO9VFm1hAlGqe%2FDAEmxAWNcDza3Nxi%2FAd8pf1OF%2BvHG1xGOBLrnSeWw48EAx2JllWGo0o4fZs%2BWaRRAEli7iBOrrxhMGHIKsQJdY2ok4f5&X-Amz-Signature=63ac648a342a93793bf4c236b176a5a4d9769735f6576395849c46429fc6ba61&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%222026-02-06-Cupi-Statements.csv%22&x-id=GetObject";
    // === IMPORTANT FIX ===
    if (typeof url === "string") {
      // Replace escaped & with real &
      url = url.replace(/\\u0026/g, "&");

      // Also handle other possible escapes
      url = url.replace(/&amp;/g, "&");
    }

    console.log("Cleaned Presigned URL:", url);

    try {
      const response = await fetch(url);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("S3 Error Response:", errorText);
        throw new Error(`Download failed: ${response.status}`);
      }

      const blob = await response.blob();

      // Trigger download
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = resData?.filename || "2026-01-01-Cupi-Statements.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(downloadUrl);

      console.log("✅ Download started successfully");
    } catch (error) {
      console.error("❌ Download error:", error);
    }
  };


  const readCsvRaw = async (url) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch CSV: ${res.status}`);
    return await res.text();
  };

  const handleFetchAndCombine = async () => {
    if (!data || data.length === 0) return;

    try {
      const urls = data.map(item => item.url).filter(Boolean);

      let allDataRows = [];
      let header = null;
      // let openingBalanceLine = null;

      for (let i = 0; i < urls.length; i++) {
        console.log(`Downloading file ${i + 1}/${urls.length}...`);
        const csvText = await readCsvRaw(urls[i]);
        const lines = csvText.trim().split("\n");

        let dataStarted = false;

        for (const line of lines) {
          if (line.includes("Opening Balance")) {
            //  openingBalanceLine = line;
            allDataRows.push(line);
            continue
          }
          if (line.includes("Stmt Id") && line.includes("Transaction Date")) {
            if (!header) header = line;
            dataStarted = true;
            continue;
          }

          if (dataStarted && line.trim() !== "") {
            allDataRows.push(line);
          }
        }
      }

      // Sort by Transaction Date
      allDataRows.sort((a, b) => {
        const dateA = a.split(",")[1]?.trim();
        const dateB = b.split(",")[1]?.trim();
        return new Date(dateA) - new Date(dateB);
      });

      // Build final CSV
      const finalLines = [];
      if (header) finalLines.push(header);
      finalLines.push(...allDataRows);

      const finalCsv = finalLines.join("\n");
      const fileName = `${selectedYear}-${selectedMonth}-CUPI-Statement.csv`;

      const blob = new Blob([finalCsv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    (async () => {
      if (!Clicked && gotResponse) {
        setShowSuccess(true);
        await new Promise((resolve) => setTimeout(resolve, 5000));
        setShowSuccess(false);
      }
    })();
  }, [Clicked]);

  return (
    <Fragment>
      {/* <div className={styles.NoteContainer}>
        <div className={styles.NoteContent}>
          <span className={styles.Bold}>Note:</span> The UTR for the wallet
          loads will not match because of an issue at Pine Labs PPI escrow
          account. We are working on updating the system to reflect the correct
          UTR. Please note that the amount and date will match.
        </div>
      </div> */}
      <div className={styles.Container}>
        <div className={styles.FilterContainer}>
          <div className={styles.FilterContainer1}>
            <select
              className={styles.Filter}
              value={selectedYear}
              onChange={async (e) => {
                setSelectedYear(e.target.value);
                GetStatementsData(e.target.value, selectedMonth);
              }}
            >
              <option value="" disabled>
                Select Year
              </option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <select
              className={styles.Filter}
              value={selectedMonth}
              onChange={(e) => {
                setSelectedmonth(e.target.value);
                GetStatementsData(selectedYear, e.target.value);
              }}
            >
              <option value="" disabled>
                Select Month
              </option>
              {monthOptions.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <div className={styles.AlertContainer}>
              Note:{" "}
              <span className={styles.AlertSpan}>
                You can download statements only for the dates on which your
                employees spent with CUPI.
              </span>
            </div>
          </div>
          {/* {ShowSuccess && !Error && (
            <div className={styles.SuccessAlertContainer}>
              <img
                className={styles.filterLinesIcon}
                alt=""
                src="/check-circle.svg"
              />
              <span>Statements downloaded successfully!</span>
            </div>
          )} */}
          {Error && (
            <div className={styles.ErrorAlertContainer}>
              <div>{ErrorMsg.Title}</div>
              <span className={styles.ErrorAlertSpan}>{ErrorMsg.message}!</span>
            </div>
          )}
        </div>
        <div className={styles.tableContainer}>
          {(selectedYear && gotResponse && data.length>0 )&& (
            <div className={styles.GenerateMonthlyReport}>
              <div className={styles.GenerateMonthlyContainer1}>
                <div className={styles.GenerateMonthlyNote}>
                  <span className={styles.Bold}>Note:</span> You can generate a
                  single file that includes all the user spending statements
                  available so far for this month.
                </div>
                <div
                  className={styles.GenerateMonthlyDate}
                >{`${selectedYear}-${selectedMonth}-CUPI-Statement.csv`}</div>
              </div>
              <div className={styles.GenerateMonthlyContainer2}>
               {!DownloadingProgess? <div
                  className={styles.GenerateMonthlyButton}
                  onClick={async() => {
                    setDownloadingProgess(true)
                    await handleFetchAndCombine();
                    setDownloadingProgess(false)
                  }}
                >
                  <img
                    className={styles.filterLinesIcon}
                    alt=""
                    src="/Generate_Report_icon.svg"
                  />
                  <span className={styles.underline}>Generate</span>
                </div>:<div
                  className={styles.GenerateMonthlyButton}
                 
                >
                  <img
                    className={styles.filterLinesIcon}
                    alt=""
                    src="/Blue_Download_Icon.svg"
                  />
                  <span className={styles.underline}>Downloading...</span>
                </div>}
              </div>
            </div>
          )}
          {(selectedYear && gotResponse && data?.length > 0) ? (
            <table className={styles.ReportTable}>
              <tbody className={styles.TableBody}>
                {data?.map((res) => (
                  <tr key={res.statement_name} className={styles.TableRow}>
                    <td className={styles.TableMonth}>{res?.statement_name}</td>
                    <td className={styles.TableButton}>
                      {Clicked && ClickedStmt == res?.statement_name ? (
                        <button className={styles.GenerateButtonDis}>
                          <img
                            className={styles.filterLinesIcon}
                            alt=""
                            src="/Blue_Download_Icon.svg"
                          />
                          <span className={styles.GenerateButtonText}>
                            Downloading...
                          </span>
                        </button>
                      ) : (
                        <button
                          className={styles.GenerateButton}
                          onClick={async () => {
                            // setClicked(true);
                            setClickedStmt(res.statement_name);
                            await handleDownloadStatement(
                              res.statement_name,
                              res.url,
                            );
                            // await new Promise((resolve) =>
                            //   setTimeout(resolve, 1500),
                            // );
                            // setClicked(false);
                          }}
                        >
                          <img
                            className={styles.filterLinesIcon}
                            alt=""
                            src="/Blue_Download_Icon.svg"
                          />
                          <span className={styles.GenerateButtonText}>
                            Download
                          </span>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className={styles.NoTableData}>
              No statements found. Please select a valid year and month to view
              your statement.
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
});

export default Statement;
